/**
 * Sinaliza visualmente que o app está rodando em homolog.
 * Hardcoded em pt-BR — mensagem fixa de ambiente, não passa por i18n
 * (banner é operacional, não vai pra prod).
 */
export function EnvBanner() {
  const env = import.meta.env.VITE_ENV;
  if (env !== 'homolog') return null;

  return (
    <div
      role="status"
      aria-live="polite"
      // shrink-0: o banner é irmão do miolo dentro do flex column h-dvh do App.
      // Sem ele o flex pode espremê-lo e a conta de altura do miolo passa a
      // mentir, empurrando o rodapé sticky do wizard para fora da tela.
      className="shrink-0 bg-yellow-400 px-3 py-1 text-center text-xs font-semibold leading-snug text-[#1F3A6B] border-b border-yellow-600 sm:text-sm"
    >
      AMBIENTE DE HOMOLOGACAO &mdash; dados podem ser resetados a qualquer momento
    </div>
  );
}
